import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import {RightSidebarFloatingPanel} from "../../layout/rightSidebar/RightSidebarFloatingPanel";
import {RightSidebarPanelHeader} from "../../layout/rightSidebar/RightSidebarPanelHeader";
import {RightSidebarPanelButton} from "../../layout/rightSidebar/RightSidebarRail";
import RestaurantOccupancyStats, {
    type OccupancyStatsScope,
} from "../calendar/RestaurantOccupancyStats";

interface ReservationCalendarStatisticsButtonProps {
    scope: OccupancyStatsScope;
}

export function ReservationCalendarStatisticsButton({
    scope,
}: ReservationCalendarStatisticsButtonProps) {
    const {t} = useTranslation();

    return (
        <RightSidebarPanelButton
            icon={<AnalyticsOutlinedIcon/>}
            label={t("Statistics")}
            renderPanel={close => (
                <RightSidebarFloatingPanel sx={{overflow: "hidden"}}>
                    <RightSidebarPanelHeader title={t("Statistics")} onClose={close}/>
                    <Stack gap={1.5} sx={{flex: 1, minHeight: 0, overflowY: "auto", px: 2, pb: 2}}>
                        <Typography variant="body2" color="text.secondary">
                            {t("Restaurant Occupancy Statistics")}
                        </Typography>
                        <RestaurantOccupancyStats fullWidth scope={scope}/>
                    </Stack>
                </RightSidebarFloatingPanel>
            )}
        />
    );
}
